import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
  conceptTitle: string;
  message?: string;
}

@Component({
    selector: 'app-location-service-delete-dialog',
    templateUrl: './location-service-delete-dialog.component.html',
    styleUrls: ['./location-service-delete-dialog.component.css'],
    standalone: false
})
export class LocationServiceDeleteDialogComponent {
  public message: string;

  constructor(
    public dialogRef: MatDialogRef<LocationServiceDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.message = data.message || `¿Está seguro que desea eliminar el concepto "${data.conceptTitle}"?`;
  }

  public delete(): void {
    this.dialogRef.close(true);
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }
}
